import React from "react";
// import notificationlogo from "../../assets/images/notificationlogo.jpg";
// import profilelogo from "../../assets/images/profilelogo.jpeg";
import { Container, Form, Nav, Navbar, NavDropdown } from "react-bootstrap";
import Badge from "../../assets/images/badge.png";
import Logo from "../../assets/images/logo.png";
import Profile from "../../assets/images/profile.jpeg";
import AddUser from "../../assets/images/addUser.svg";

import "./HeaderStyle.css";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";

const Header = () => {
  const { doLogout, profileData } = useAuthContext();
  console.log(profileData?.name , "profileData");
  
  const navigate = useNavigate();

  const handelLogout = () => {
    doLogout();
    navigate("/");
  };
  return (
    <header>
      <Navbar expand="lg" className="dashboard_header">
        <Container fluid>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse
            id="navbarScroll"
            className=" header_menu justify-content-between"
          >
            <div className="logo">
              <img src={Logo} alt="" />
            </div>
            <div className="flex_between">
              {/* <div className="notification">
                <i className="far fa-comment-alt"></i>
              </div>
              <div className="notification">
                <i className="far fa-bell"></i>
              </div> */}
              <img className="mx-3" src={Profile} alt="" />
              <span className="user_name">{profileData?.name}</span>
              <Nav className="ms-lg-2 mr-5">
                <NavDropdown
                  title={
                    <span>
                      <i class="fas fa-sort-down"></i>
                    </span>
                  }
                  id="navbarScrollingDropdown"
                  className="mr-5 profile_dropdown"
                >
                  <NavDropdown.Item onClick={() => handelLogout()}>
                    Log Out
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
